module.exports = __webpack_public_path__ + "img/upload.03a7ea61.svg";